import { useState } from 'react';

import Button from '@components/button/Button';
import { ReportDateRangePicker } from '@components/index';
import { STORAGE_KEYS } from '@constants/storage';
import { isAllOptionsSelected } from '@features/lead-management/utils/common';
import { DateRange as UIDateRange } from '@types';
import { getLocalStorageItem } from '@utils/storage';
import { DropdownOption } from 'types/dropdown';

import AgentSelector from '../AgentSelector';
import { leadDateRangeOptions } from './helper';
import { AgentReportAnalysisProps } from './types';

const AgentReportAnalysis: React.FC<AgentReportAnalysisProps> = ({
  formData,
  onFormChange,
  onDownloadReport,
  isFormValid,
  isGenerating = false,
  handleAllOptionsSelection
}) => {
  const organizationId = getLocalStorageItem(STORAGE_KEYS.ORGANIZATION_ID);
  const [currentOption, setCurrentOption] = useState<string>('');

  const handleDateRangeSelect = (dateRange: UIDateRange) => {
    onFormChange('startDate', dateRange.startDate);
    onFormChange('endDate', dateRange.endDate);
  };

  const handleMultiSelectChange = (
    field: string,
    selectedOptions: DropdownOption[],
    options: DropdownOption[]
  ) => {
    const isAllSelected = isAllOptionsSelected(selectedOptions, options);
    handleAllOptionsSelection(field, isAllSelected);
    onFormChange(field, selectedOptions);
  };

  return (
    <div className="rounded-xl bg-white p-6">
      <div className="flex flex-wrap gap-6">
        <div className="w-full md:w-[calc(33.333%-1rem)]">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Lead Creation Date <span className="text-red-500">*</span>
          </label>
          <ReportDateRangePicker
            currentFilter={currentOption}
            filterOptions={leadDateRangeOptions}
            onSelectFilter={(dateRange, option) => {
              handleDateRangeSelect(dateRange);
              setCurrentOption(option);
            }}
            customClass="w-full"
            customDropdownClass="min-h-[610px]"
          />
        </div>

        <div className="w-full md:w-[calc(33.333%-1rem)]">
          <AgentSelector
            selectedAgents={formData.assignedAgent}
            setSelectedAgents={(agents, options) =>
              handleMultiSelectChange('assignedAgent', agents, options)
            }
            organizationId={organizationId}
          />
        </div>
      </div>

      <div className="pt-6">
        <Button
          variant="primary"
          size="large"
          label="Download Report"
          handleClick={onDownloadReport}
          disabled={!isFormValid}
          loading={isGenerating}
          className="w-full px-8 py-3 md:w-auto"
        />
      </div>
    </div>
  );
};

export default AgentReportAnalysis;
